export class BulkCreateUserHasQualificationsResultDto {
  createdCount: number;
  renewedCount: number;
  recycledCount: number;
  skippedCount: number;
  skippedUserIds: string[];
}
